

export class StudentRegData {
  server_subject_id: number = 0
  server_enrolment_id: number = 0
  server_subscription_id: number = 0
  server_curriculum_id: number = 0
  local_subscription_id: number = 0
  paymentStatus: number = 0
  server_student_id: number = 0
  paymentOrderId: String = ""
  local_item_id: number = 0
  isUpgradedFromId: number = 0

  firstname: string
  lastname: string
  coupon = 0
  server_country_id
  server_level_id = 0
  server_user_id = 0
  reference_id = ""
  is_premium_subscription_type = 0

  enrol_trial_admin=0
  is_upgrading=0
  enrol_action_name=""
}



